import { render, staticRenderFns } from "./AccountSidebarItem.vue?vue&type=template&id=b25bf0b0&scoped=true&"
import script from "./AccountSidebarItem.vue?vue&type=script&lang=js&"
export * from "./AccountSidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25bf0b0",
  null
  
)

export default component.exports